import createElementFromNode from './createElementFromNode';

/**
 * Creates an element for the virtual DOM from a string of HTML. WARNING: This method does not
 * sanitize the HTML string passed to it. If you use this method you may be vulnerable to
 * XSS attacks if you do not take the right precautions.
 *
 * @method dangerouslyCreateElementFromString
 * @param {String} html String of html to parse and convert to a vnode
 * @returns {VNode} The vnode to use in the virtual DOM
 */
export default function dangerouslyCreateElementFromString(html) {
	if (!document || !document.createElement) return;

	const element = document.createElement('div');
	element.innerHTML = html;
	return createElementFromNode(element.firstChild);
}
